/** Local report/comparison options; the gear remains for workspace settings. */
export default function AdjustmentsIcon() {
  return (
    <svg aria-hidden="true" className="inline-block h-4 w-4 shrink-0 align-text-bottom" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 5h4m4 0h10M3 12h10m4 0h4M3 19h2m4 0h12" />
      <circle cx="9" cy="5" r="2" />
      <circle cx="15" cy="12" r="2" />
      <circle cx="7" cy="19" r="2" />
    </svg>
  );
}
